import {
  commonServiceInstance,
  notificationServiceInstance,
  paymentServiceInstanceUser,
} from "api";
import useSWR from "swr";
import useSWRMutation from "swr/mutation";

// PROFILE

export const sendSMS = async (url, { arg }) => {
  const response = await commonServiceInstance.post(url, arg);
  return response.data;
};

export const updateUser = async (url, { arg }) => {
  const response = await commonServiceInstance.put(url, arg);
  return response.data;
};
export const uploadImage = async (url, { arg }) => {
  const formData = new FormData();
  formData.append("file", arg.file);
  const response = await commonServiceInstance.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

export const getCommissionType = async (url) => {
  const {
    data: { value: data },
  } = await paymentServiceInstanceUser.get(url);
  return data;
};

export const updateCommissionType = async (url, { arg }) => {
  const response = await paymentServiceInstanceUser.put(
    url,
    {},
    { params: arg }
  );
  return response.data;
};

export const deleteAccount = async () => {
  const {
    data: { value: data },
  } = await commonServiceInstance.delete("/profile/soft-delete");
  return data;
};

export const cancelQRrequest = async () => {
  const {
    data: { value: data },
  } = await paymentServiceInstanceUser.delete(`/api/v1/amount-for-default`);

  return data;
};

export const generateQr = async ({ amount, currency, commissionType }) => {
  const {
    data: { value: data },
  } = await paymentServiceInstanceUser.post(`/api/merchant/product`, null, {
    params: {
      amount,
      currency,
      commissionType,
    },
  });
  return data;
};

export const getGenericTransactions =
  (params) => (pageIndex, previousPageData) => {
    if (previousPageData?.length && previousPageData?.length < 20) return null;
    return [
      `/api/v1/generic-transaction/filter?page=${pageIndex}&limit=20`,
      params,
    ];
  };

export const fetcher = async ([url, params]) => {
  try {
    const response = await paymentServiceInstanceUser.post(url, params, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data?.value || {};
  } catch (error) {
    console.error("Fetcher error:", error?.data.message);
    throw error;
  }
};

export const useLimitData = () => {
  const { data, error } = useSWR(
    `/api/limit`,
    async (url) => {
      const {
        data: { value },
      } = await paymentServiceInstanceUser.get(url);

      return value;
    },
    {
      revalidateIfStale: false,
    }
  );

  return { data, error };
};

export const usePlanData = () => {
  const { data, error } = useSWR(
    `/api/v1/plan`,
    async (url) => {
      const {
        data: { value },
      } = await paymentServiceInstanceUser.get(url);

      return value;
    },
    {
      revalidateIfStale: false,
    }
  );

  return { data, error };
};

export const useSdaToken = (enabled = false) => {
  const shouldFetch = enabled ? "/api/sda?lang=en" : null;

  const { data, error, mutate } = useSWR(
    shouldFetch,
    async (url) => {
      const {
        data: { value },
      } = await paymentServiceInstanceUser.get(url);

      return value;
    },
    {
      revalidateIfStale: true,
    }
  );

  return { data, error, mutate };
};
const verifyIdentity = async (url, { arg }) => {
  const {
    data: { value },
  } = await commonServiceInstance.post(url, { sessionToken: arg.sessionToken });
  return value;
};

export const useVerifyIdentity = () =>
  useSWRMutation("/profile/verify/identity", verifyIdentity);

export const useUpdateVerifyIdentity = (enabled = false) => {
  const shouldFetch = enabled ? "/api/v1/profile/verify/identity/update" : null;

  const { data, error, mutate } = useSWR(
    shouldFetch,
    async (url) => {
      const {
        data: { value },
      } = await commonServiceInstance.get(url);

      return value;
    },
    {
      revalidateIfStale: true,
    }
  );

  return { data, error, mutate };
};
export const saveFMAtoken = async (token) => {
  const {
    data: { value: data },
  } = await notificationServiceInstance.put(`/mobile-device`, null, {
    params: {
      device_token: token,
    },
  });
  return data;
};

export const useLoyaltyBalanceData = () => {
  const { data, error } = useSWR(
    `/api/v1/loyalty-balance`,
    async (url) => {
      const {
        data: { value },
      } = await paymentServiceInstanceUser.get(url);

      return value;
    },
    {
      revalidateIfStale: false,
    }
  );

  return { data, error };
};

// IBANS
export const useIbansData = () => {
  const { data, error, isValidating, mutate } = useSWR(
    `/ibans`,
    async (url) => {
      const {
        data: { value },
      } = await commonServiceInstance.get(url);

      return value;
    }
  );

  return { data, error, isValidating, refetch: mutate };
};

export const useCryptoWalletProviders = (enabled) => {
  const { data, error, isValidating } = useSWR(
    enabled ? `/crypto-wallet/provider` : null,
    async (url) => {
      const {
        data: { value },
      } = await commonServiceInstance.get(url);

      return value;
    }
  );

  return { data, error, isValidating };
};
export const createIban = async (url, { arg }) => {
  const response = await commonServiceInstance.post(url, arg);
  return response.data;
};

export const updateIban = async (url, { arg }) => {
  const response = await commonServiceInstance.put(url, arg);
  return response.data;
};

export const deleteIban = async (url) => {
  const {
    data: { value: data },
  } = await commonServiceInstance.delete(url);

  return data;
};

//

export const logout = async () => {
  try {
    const {
      data: { value: data },
    } = await commonServiceInstance.post(`/profile/logout`);

    localStorage.removeItem("userToken");
    localStorage.removeItem("refreshToken");

    return data;
  } catch (error) {
    console.error("Logout failed:", error);
    throw error;
  }
};

// CARDS AND BANKS

export const getUserCards = (params) => (pageIndex, previousPageData) => {
  if (previousPageData?.length && previousPageData?.length < 20) return null;
  return [`/api/user-card?page=${pageIndex}&limit=20`, params];
};

export const cardsFetcher = async ([url, params]) => {
  try {
    const response = await paymentServiceInstanceUser.get(url, params, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data?.value || {};
  } catch (error) {
    console.error("Fetcher error:", error?.data.message);
    throw error;
  }
};
export const getBOGuri = async (url, { arg }) => {
  const response = await paymentServiceInstanceUser.post(url, arg);
  return response.data;
};

export const deleteCard = async (url) => {
  const {
    data: { value: data },
  } = await paymentServiceInstanceUser.delete(url);

  return data;
};
